<template>
  <div class="display">
    <div class="row-1">
      <img
        class="warning-title-bg"
        src="../../../../static/img/display-img/show_new/bg_tit_all.png"
      />
      <div class="warning-title" >报警信息</div>
    </div>
    <div class="row-2">
      <div class="table-header">
        <div class="table-header-no">排序</div>
        <div class="table-header-type">报警类型</div>
        <div class="table-header-name">报警对象</div>
        <div class="table-header-time">报警时间</div>
      </div>
      <div v-for="(item, index) in warning" :key="index" class="table-item">
        <div v-if="index % 2 === 0" class="table-item-bg table-item-bg-light"></div>
        <div v-else class="table-item-bg table-item-bg-dark"></div>
        <div class="table-item-no">
          <div v-if="index % 2 === 0" class="table-item-no-bg table-item-no-green">{{index}}</div>
          <div v-else class="table-item-no-bg table-item-no-red">{{index}}</div>
        </div>
        <div class="table-item-type">{{item.type}}</div>
        <div class="table-item-name">{{item.name}}</div>
        <div class="table-item-time">{{item.time}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import data from './assets/data.js';
export default {
  name: "buttomDisplay",
  mixins: [data],
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
	mounted() {
		// this.query()
	},
  methods: {
		// 查询
  },
  created() {
  },
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
};
</script>
<style lang='scss' scoped>
.display {
  width: 100%;
  height: 100%;
  .row-1{
    z-index: 100;
    width: 120px;
    height: 26px;
    position: relative;
    text-align: left;
    .warning-title-bg{
      position: absolute;
      width: 120px;
      height: 26px;
    }
    .warning-title{
      position: absolute;
      left: 17px;
      text-align: left;
      font-size: 20px;
      color: #FFFFFF;
    }
  }
  .row-2{
    margin-top: 16px;
    width: 950px;
    height: 186px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .table-header, .table-item{
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    }
    .table-header{
      height: 25px;
      width: 100%;
      background-color: rgba(0, 65, 196, 0.2);
      color: rgba(39, 184, 255, 1);
      font-weight: 400;
      font-size: 15px;
      >div{
        font-size: inherit;
      }
    }
    .table-item{
      position: relative;
      height: 21px;
      width: 100%;
      color: #FFFFFF;
      font-weight: 400;
      font-size: 13px;
      >div{
        font-size: inherit;
      }
      .table-item-bg{
        position: absolute;
        width: 100%;
        height: 100%;
      }
      .table-item-bg-dark{
        background: #003194;
        opacity: 0.2;
      }
      .table-item-bg-light{
        background: #0053FF;
        opacity: 0.2;
      }
      .table-header-no{
        color: rgba(0, 0, 0, 1);
      }
      .table-item-no-bg{
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        color: #000000;
        line-height: 14px;
        position: absolute;
        top: 4px;
        width: 13px;
        height: 13px;
      }
      .table-item-no-green{
        background-color: rgba(109, 217, 255, 1);
      }
      .table-item-no-red{
        background-color: rgba(255, 71, 124, 1);
      }
    }
    .table-header-no, .table-item-no{
      width: 120px;
      text-align: left;
    }
    .table-header-type, .table-item-type{
      width: 260px;
      text-align: left;
    }
    .table-header-name, .table-item-name{
      width: 250px;
      text-align: left;
    }
    .table-header-time, .table-item-time{
      width: 130px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ProductDetails/mod_screen_display_show/buttomDisplay.vue